import React from 'react';

export const AccountManagementPage: React.FC = () => {
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-4">계정 관리</h2>
      <p>계정 관리 페이지가 여기에 표시됩니다.</p>
    </div>
  );
};